import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { AutocompleteOptions } from '@Components/Autocomplete';
import Select from '@Components/Select';
import { ReactHookFormError } from '@Typings/global.types';

import SelectWrapperProps from './SelectFieldWrapper.types';

const SelectFieldWrapper: FunctionComponent<SelectWrapperProps> = (
  props: SelectWrapperProps
): JSX.Element => {
  const {
    name,
    textFieldProps,
    onChange,
    initialValue,
    multiple,
    ...resProps
  } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();

  /** Handles Select Value null state */
  const getValue = (
    value?: AutocompleteOptions | AutocompleteOptions[] | null
  ) => {
    if (multiple) {
      return value && (value as AutocompleteOptions[]).length
        ? (value as AutocompleteOptions[])
        : [];
    }

    return value &&
      ((value as AutocompleteOptions).label ||
        (value as AutocompleteOptions).value)
      ? (value as AutocompleteOptions)
      : null;
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={getValue(initialValue)}
      render={({ field }) => (
        <Select
          {...resProps}
          multiple={multiple}
          error={!!errors[name]}
          onChange={(event, value, reason, details) => {
            if (onChange) {
              onChange(event, value, reason, details);
            }
            field.onChange(value);
          }}
          textFieldProps={{
            ...textFieldProps,
            helperText:
              (
                (errors[name] as AutocompleteOptions)
                  ?.value as unknown as ReactHookFormError
              )?.message || (errors[name] as ReactHookFormError)?.message,
          }}
          value={getValue(field.value)}
        />
      )}
    />
  );
};

SelectFieldWrapper.defaultProps = {
  initialValue: null,
};

export default SelectFieldWrapper;
